import { ref } from 'vue';
import { detectMobile } from '@/components/helpers/mobile-helper';

const readReportBoostEnabled = () =>
  JSON.parse(window.localStorage.getItem('report-boost-enabled') || 'false');

const createMobileState = () => ({
  menuOpen: false,
  menuGroupingOpen: false,
  menuGroupingTop: 0,
  menuReportTabsOpen: false,
  menuReportTabsTop: 0,
  isMobile: detectMobile(),
});

export const createLayoutUiModule = () => {
  const tutorial = ref({
    quickStart: false,
    quickStartStep: 0 as string | number,
    quickStartSection: null as string | null,
    quickStartHiddenClass: false,
  });

  const liveChatOpen = ref(false);

  const reportBoostEnabled = ref(readReportBoostEnabled());

  const desktopViewForced = ref<boolean | null>(detectMobile() ? false : null);

  const desktopViewForcedCurrent = ref<boolean | null>(detectMobile() ? false : null);

  const mobile = ref(createMobileState());

  const setMenuOpen = (value: boolean) => {
    mobile.value.menuOpen = value;
  };

  const setMenuGroupingOpen = (value: boolean) => {
    mobile.value.menuGroupingOpen = value;
  };

  const setMenuGroupingTop = (value: number) => {
    mobile.value.menuGroupingTop = value;
  };

  const setMenuReportTabsOpen = (value: boolean) => {
    mobile.value.menuReportTabsOpen = value;
  };

  const setMenuReportTabsTop = (value: number) => {
    mobile.value.menuReportTabsTop = value;
  };

  const setTutorialQuickStart = (value: boolean) => {
    tutorial.value.quickStart = value;
  };

  const setTutorialQuickStartStep = (value: string | number) => {
    tutorial.value.quickStartStep = value;
  };

  const setTutorialQuickStartHiddenClass = (value: boolean) => {
    tutorial.value.quickStartHiddenClass = value;
  };

  const setTutorialQuickStartSection = (value: string | null) => {
    tutorial.value.quickStartSection = value;
  };

  const toggleTutorialQuickStart = () => {
    setTutorialQuickStart(!tutorial.value.quickStart);
  };

  const setLiveChatOpen = (value: boolean) => {
    liveChatOpen.value = value;
  };

  const setReportBoostEnabled = (value: boolean) => {
    reportBoostEnabled.value = value;
    window.localStorage.setItem('report-boost-enabled', JSON.stringify(value));
  };

  const setDesktopViewForced = (value: boolean | null) => {
    desktopViewForced.value = value;
  };

  const setDesktopViewForcedCurrent = (value: boolean | null) => {
    desktopViewForcedCurrent.value = value;
  };

  const reset = () => {
    tutorial.value = {
      quickStart: false,
      quickStartStep: 0,
      quickStartSection: null,
      quickStartHiddenClass: false,
    };
    liveChatOpen.value = false;
    reportBoostEnabled.value = readReportBoostEnabled();
    desktopViewForced.value = detectMobile() ? false : null;
    desktopViewForcedCurrent.value = detectMobile() ? false : null;
    mobile.value = createMobileState();
  };

  return {
    state: {
      tutorial,
      liveChatOpen,
      reportBoostEnabled,
      desktopViewForced,
      desktopViewForcedCurrent,
      mobile,
      setMenuOpen,
      setMenuGroupingOpen,
      setMenuGroupingTop,
      setMenuReportTabsOpen,
      setMenuReportTabsTop,
      setTutorialQuickStart,
      setTutorialQuickStartStep,
      setTutorialQuickStartHiddenClass,
      setTutorialQuickStartSection,
      toggleTutorialQuickStart,
      setLiveChatOpen,
      setReportBoostEnabled,
      setDesktopViewForced,
      setDesktopViewForcedCurrent,
    },
    reset,
  };
};
